<template>
  <i
    class="tm-overlay-sprite"
    :class="{
      d: $props.showDim,
    }"
  >
    <i
      v-for="(spriteRectangle, i) in sprite"
      :key="i"
      :style="spriteRectangle.styleObj"
    />
  </i>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  generateSpriteRectangles,
  getColourCardCss,
} from '../../../../api/asset';

export default {
  name: 'tm-overlay-sprite',

  props: {
    overlay: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    showDim: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
  },

  data() {
    return {
      colourCardCss: null,
    };
  },

  computed: {
    ...mapGetters('timemachine', ['grid']),
    ...mapState('timemachine', {
      pxAssetWidth: (state) => state.cssVariables.pxAssetWidth,
      pxOverlayH: (state) => state.cssVariables.pxOverlayH,
    }),

    wallpaperMetaData() {
      return this.$props.overlay.wallpaperMetaData;
    },

    sprite() {
      return generateSpriteRectangles(
        this.grid,
        this.$props.overlay,
        this.$props.rectangle,
        this.pxAssetWidth,
        this.pxOverlayH,
        false,
        this.$data.colourCardCss
      );
    },
  },

  watch: {
    wallpaperMetaData: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.$data.colourCardCss = getColourCardCss(value.wallpaperData);
        }
      },
    },
  },
};
</script>

<style lang="scss">
.tm-overlay-span > .tm-overlay-sprite {
  position: absolute;
  top: 0;
  z-index: var(--tm-zOverlaySprite);
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;

  &.d:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }

  > i {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
